<template>
	<div class="">
		<Breadcrumb/>
		<div class="wrap">
			<Title title="我的收藏"></Title>
			<el-table @row-click="showStudentDialog" size="mini" border :data="hotStudentList" style="width: 100%" :cell-style="cellStyle">
				<el-table-column type="index">
				</el-table-column>
				<el-table-column prop="userName" label="姓名" height="30" width="200">
				</el-table-column>
				<el-table-column prop="school" label="学校" height="30" width="200">
				</el-table-column>
				<el-table-column prop="school" label="收藏时间">
					<template slot-scope="scope">
						{{scope.row.likeTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="取消收藏">
					<template slot-scope="scope">
						<img @click.stop="cancelCollectStu(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_02.png"/>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		</div>
		<!--报名表详情弹窗-->
		<el-dialog title="报名表详情" :visible.sync="dialogTable" width="50%" @click="dialogTable=false">
			<table class="dialog-table">
				<tr>
					<th>假期名称</th>
					<td>{{enrollModel.vacationName}}</td>
				</tr>
				<tr>
					<th>姓名</th>
					<td>{{enrollModel.userName}}</td>
				</tr>
				<tr>
					<th>学校</th>
					<td>{{enrollModel.school}}</td>
				</tr>
				<tr>
					<th>年级</th>
					<td>{{enrollModel.grade}}</td>
				</tr>
				<!-- <tr>
					<th>学生证</th>
					<td><img class="certificate" src="@/assets/login.png"/></td>
				</tr> -->
				<tr>
					<th>专业</th>
					<td>{{enrollModel.major}}</td>
				</tr>
				<tr>
					<th>省份名称</th>
					<td>{{enrollModel.provinceName}}</td>
				</tr>
				<tr>
					<th>城市名称</th>
					<td>{{enrollModel.cityName}}</td>
				</tr>
				<tr>
					<th>区县名称</th>
					<td>{{enrollModel.districtName}}</td>
				</tr>
				<tr>
					<th>详细地址</th>
					<td>{{enrollModel.returnAddress}}</td>
				</tr>
				<tr>
					<th>身份证号</th>
					<td>{{enrollModel.idCard}}</td>
				</tr>
				<tr>
					<th>电话</th>
					<td>{{enrollModel.showPhone}}</td>
				</tr>
				<tr>
					<th></th>
					<td class="title-more" @click="showFeed(enrollModel.memberId)">看TA的活动动态</td>
				</tr>
			</table>
		</el-dialog>
		<!--学生动态弹窗-->
		<el-dialog title="TA的动态" :visible.sync="dialogFeed" width="60%" @click="closeFeed">
			<div class="dialog-school-wrap">
				<el-table @row-click="feedRowClick" size="mini" border :data="feedList" style="width: 100%" :cell-style="cellStyle">
					<el-table-column prop="title" label="标题" width="400">
					</el-table-column>
					<el-table-column label="动态类型">
						<template slot-scope="scope">
							<span v-if="scope.row.feedType==0">文字动态</span>
							<span v-if="scope.row.feedType==1">图片动态 <i class="preview-btn">查看</i></span>
							<span v-if="scope.row.feedType==2">视频动态 <i class="preview-btn">查看</i></span>
						</template>
					</el-table-column>
					<el-table-column label="发布时间">
						<template slot-scope="scope">
							<span>{{scope.row.addTime | datefmt2('YYYY-MM-DD HH:mm')}}</span>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :total="feedTotal" :pageSize="feedPageSize" @pageChange="handleFeedChange"/>
			</div>
		</el-dialog>
		<!--视频预览-->
		<el-dialog title="视频预览" :visible.sync="videoDialog" width="50%" @close="handleClose('video')">
			<div class="video-wrap">
				<video ref="videoPreview" controls muted autoplay :src="feedDetailModel.fileUrl"></video>
			</div>
		</el-dialog>
		<!--动态图片预览-->
		<el-dialog title="图片预览" :visible.sync="imgDialog" width="50%" @close="handleClose('img')">
			<div class="picture-wrap">
				<div class="picture-list" v-for="item in feedDetailModel.attachList">
					<!-- <img :src="item.fileUrl"/> -->
					<el-image 
					    style="width: 100%; height: 100px;"
					    :src="item.fileUrl" 
					    :preview-src-list="attachList">
					  </el-image>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Breadcrumb from '@/components/admin/breadcrumb'
	import Pagination from '@/components/admin/pagination'
	export default {
		name: 'StudentCollect',
		components: {
			Title,
			Breadcrumb,
			Pagination
		},
		data(){
			return {
				hotStudentList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dialogTable: false,
				enrollModel: {},
				feedList: [],
				dialogFeed: false,
				feedPageNum: 1,
				feedPageSize: 10,
				feedTotal: 0,
				feedUserId: '',
				vacationId: '',
				feedDetailModel: {},
				videoDialog: false,
				imgDialog: false,
				attachList: []
			}
		},
		created(){
			this.getHotStudentList()
		},
		methods: {
			//获取热力学生榜
			async getHotStudentList(){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/likeList', qs.stringify(param))
				if (res.data.code == 200) {
					this.hotStudentList = res.data.page.items
					this.total = res.data.page.count
				}
			},
			showStudentDialog(e){
				this.getEnrollDetail(e.id)
				this.dialogTable = true
			},
			//获取报名表详情
			async getEnrollDetail(id){
				let param = {
					id: id
				}
				ajaxParam(param)
				const res = await post('admin/enroll/detail', qs.stringify(param))
				if (res.data.code == 200) {
					this.enrollModel = res.data.entity
				}
			},
			//分页
			handleCurrentChange(e){
				this.hotStudentList = []
				this.pageNum = e.number
				this.getHotStudentList()
			},
			//取消收藏大学生
			async cancelCollectStu(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/delete', qs.stringify(param))
				if (res.data.code == 200) {
					//取消收藏成功
					this.$message.success('取消收藏成功！')
					this.hotStudentList.forEach((item, index)=>{
						if(item.id==id) {
							this.hotStudentList.splice(index,1)
						}
					})
				}
			},
			handleFeedChange(e){
				this.feedList = []
				this.feedPageNum = e.number
				this.getFeedList(this.feedUserId)
			},
			//关闭学生动态
			closeFeed(){
				this.dialogFeed=false
				this.feedUserId = ''
			},
			showFeed(userId){
				this.dialogFeed = true
				this.feedUserId = userId
				this.getFeedList(userId)
			},
			//获取学生动态
			async getFeedList(userId) {
				let param = {
					vacationId: this.vacationId,
					userId: userId,
					pageNum: this.feedPageNum,
					pageSize: this.feedPageSize
				}
				ajaxParam(param)
				const res = await post('admin/feed/list', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.feedList = datalist
					this.feedTotal = res.data.page.count
				}
			},
			//动态视频预览
			toVideo(row){
				this.getFeedDetail(row)
				this.videoDialog = true
			},
			//动态图片预览
			toPicture(row){
				this.getFeedDetail(row)
				this.imgDialog = true
			},
			async getFeedDetail(row){
				let param = {
					id: row.id
				}
				ajaxParam(param)
				const res = await post('admin/feed/detail', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					let entity = res.data.entity
					this.feedDetailModel = entity
					if(entity.feedType ==1){
						entity.attachList.forEach(item=>{
							this.attachList.push(item.fileUrl)
						})
					}
				}
			},
			feedRowClick(row){
				if(row.feedType==1) {
					this.toPicture(row)
				} else if(row.feedType==2){
					this.toVideo(row)
				}
			},
			handleClose(type){
				if(type=='img'){
					this.imgDialog = false
				} else if(type=='video'){
					const videoPlayer = this.$refs.videoPreview;
					if (videoPlayer) {
						videoPlayer.pause(); // 暂停视频
					}
					this.videoDialog = false
				}
			},
			cellStyle(){
				return "cursor:pointer;"
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}
	.dialog-table{
		width: 100%;
		font-size: 12px;
		th{
			width: 130px;
			background: #F3F4F6;
		}
		th,td{
			padding: 8px 20px;
			border: 1px solid #DBDCDC
		}
		td .certificate{
			width: 130px;
		}
	}
	.title-more {
		color: #EB6B1B;
		cursor: pointer;
		font-size: 14px;
		font-weight: bold;
		a {
			color: #EB6B1B;
		}
	}
	.video-wrap{
		video{
			width: 100%;
			max-width: 100%;
			max-height: 400px;
		}
	}
	.picture-wrap{
		display: flex;
		flex-wrap: wrap;
		.picture-list{
			width: 31.3%;
			margin: 0 1% 5px;
		}
	}
	.preview-btn{
		color: #EB6B1B
	}
</style>
